import {tenantService} from "@/services/TenantService.class";
import {accountService} from "@/services/AccountService.class";
import {adminAccountService} from "@/services/AdminAccountService.class";

const state = {
  tenants: [],
  selectedTenant: null,
  tenantAccounts: [],
  tenantRootAccounts: [],
  tenantCustomers: [],
  allCustomers: []
};

const actions = {
  getSelf({commit}) {
    return tenantService.getSelf().then((response) => {
      commit('setSelectedTenant', response.data);
      return response.data;
    });
  },

  getTenants({commit}) {
    return tenantService.get().then((response) => {
      commit('setTenants', response.data);
      return response.data;
    });
  },

  getTenantById({commit}, tenantId) {
    return tenantService.getById(tenantId).then((response) => {
      commit('setSelectedTenant', response.data);
      return response.data;
    });
  },

  getTenantRootAccounts({commit}, tenantId) {
    return tenantService.getTenantRootAccounts(tenantId).then((response) => {
      commit('setTenantRootAccounts', response.data);
      return response.data;
    });
  },

  getTenantAccounts({commit}, {tenantId, filterParams = {}, pageParams = {}}) {
    return tenantService.getTenantAccounts(tenantId, filterParams, pageParams).then((response) => {
      commit('setTenantAccounts', response.data);
      return response.data;
    });
  },

  createTenant({dispatch}, tenant) {
    return tenantService.create(tenant).then(() => {
      return dispatch('getTenants');
    });
  },

  updateTenant({dispatch}, {tenantId, tenant}) {
    return tenantService.patch(tenantId, tenant).then(() => {
      return dispatch('getTenants');
    });
  },

  deleteTenant({dispatch}, tenantId) {
    return tenantService.delete(tenantId).then(() => {
      return dispatch('getTenants');
    });
  },

  createTenantAccount({dispatch}, {tenantId, account}) {
    return tenantService.createTenantAccount(tenantId, account).then(() => {
      return dispatch('getTenantAccounts', {tenantId});
    });
  },

  // Account management
  setAccountActive({dispatch}, {tenantId, accountId, isActive}) {
    return adminAccountService.setAccountActive(accountId, isActive).then(() => {
      return dispatch('getTenantAccounts', {tenantId});
    });
  },

  updateAccount({dispatch}, {tenantId, accountId, account}) {
    return adminAccountService.updateAccount(accountId, account).then(() => {
      return dispatch('getTenantAccounts', {tenantId});
    });
  },

  deleteAccount({dispatch}, {tenantId, accountId}) {
    return adminAccountService.deleteAccount(accountId).then(() => {
      return dispatch('getTenantAccounts', {tenantId});
    });
  },

  testMailAccount({commit}, accountId) {
    return adminAccountService.sendTestEmail(accountId);
  },

  testPushAccount({commit}, accountId) {
    return adminAccountService.sendTestPush(accountId);
  },

  deleteAccountTokens({dispatch}, {tenantId, accountId}) {
    return adminAccountService.deleteAllDeviceTokens(accountId).then(() => {
      return dispatch('getTenantAccounts', {tenantId});
    });
  },

  // Customers management
  getAllCustomers({commit}) {
    return tenantService.getAllCustomers().then((response) => {
      commit('setAllCustomers', response.data);
      return response.data;
    });
  },

  getCustomersByTenant({commit}, tenantId) {
    return tenantService.getCustomersByTenant(tenantId).then((response) => {
      commit('setTenantCustomers', response.data);
      return response.data;
    });
  },

  createCustomer({dispatch}, {tenantId, customer}) {
    return tenantService.createCustomer(tenantId, customer).then(() => {
      return dispatch('getCustomersByTenant', tenantId);
    });
  },

  deleteCustomer({dispatch}, {tenantId, customerId}) {
    return tenantService.deleteCustomer(tenantId, customerId).then(() => {
      return dispatch('getCustomersByTenant', tenantId);
    });
  },

  setTenantActive({dispatch}, {tenantId, isActive}) {
    return tenantService.setActive(tenantId, isActive).then(() => {
      return dispatch('getTenants');
    });
  },

  // Global account management
  createGlobalAccount({dispatch}, account) {
    return tenantService.createAccount(account).then(() => {
      if (account.tenantId) {
        return dispatch('getTenantAccounts', {tenantId: account.tenantId});
      }
    });
  },

  // Account-Customer assignments
  assignCustomerToAccount({dispatch}, {tenantId, customerId, accountId}) {
    return accountService.assignCustomerToAccount(customerId, accountId).then(() => {
      return dispatch('getTenantAccounts', {tenantId});
    });
  }
};

const mutations = {
  setTenants(state, tenants) {
    state.tenants = tenants;
  },

  setSelectedTenant(state, tenant) {
    state.selectedTenant = tenant;
  },

  setTenantAccounts(state, accounts) {
    state.tenantAccounts = accounts;
  },

  setTenantRootAccounts(state, accounts) {
    state.tenantRootAccounts = accounts;
  },

  setTenantCustomers(state, customers) {
    state.tenantCustomers = customers;
  },

  setAllCustomers(state, customers) {
    state.allCustomers = customers;
  },

  updateTenantLogo(state, logoUrl) {
    if (state.selectedTenant) {
      state.selectedTenant.logo = logoUrl;
    }
  }
};

const getters = {
  getTenants(state) {
    return state.tenants;
  },

  getSelectedTenant(state) {
    return state.selectedTenant;
  },

  getTenantAccounts(state) {
    return state.tenantAccounts;
  },

  getTenantRootAccounts(state) {
    return state.tenantRootAccounts;
  },

  getTenantCustomers(state) {
    return state.tenantCustomers;
  },

  getAllCustomers(state) {
    return state.allCustomers;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
